function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { useMemo } from 'react';
import IconChevronLeft from '~icons/ci/chevron-left';
import IconChevronRight from '~icons/ci/chevron-right';
import { theme } from '@arc/frontend/ui-theme';
import { calculatePageOptions } from './calculatePageOptions';
const styles = {
  buttonsWrap: process.env.NODE_ENV === "production" ? {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
  } : {
    name: "1fsnsbu-buttonsWrap",
    styles: "display:flex;align-items:center;label:buttonsWrap;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  button: /*#__PURE__*/css({
    backgroundColor: theme.colors.background.paper,
    borderColor: theme.colors.input.border,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '2rem',
    borderWidth: '1px',
    color: theme.colors.text.primary
  }, "align-items:center;cursor:default;border-right:none;min-width:32px;" + (process.env.NODE_ENV === "production" ? "" : ";label:button;")),
  rightArrowBtn: /*#__PURE__*/css({
    borderRight: 'solid 1px',
    borderColor: theme.colors.input.border
  }, process.env.NODE_ENV === "production" ? "" : ";label:rightArrowBtn;"),
  buttonActive: /*#__PURE__*/css({
    '&:hover': {
      backgroundColor: theme.colors.background.tableHeader
    },
    cursor: 'pointer'
  }, process.env.NODE_ENV === "production" ? "" : ";label:buttonActive;"),
  buttonSelected: /*#__PURE__*/css({
    backgroundColor: theme.colors.input.border,
    cursor: 'default'
  }, process.env.NODE_ENV === "production" ? "" : ";label:buttonSelected;")
};
export function ListPageSelector({
  totalItems = 0,
  rowsPerPage,
  page,
  onChangePage,
  delta = 2,
  alwaysShowFirstPage = true,
  alwaysShowLastPage = true
}) {
  const lastPage = useMemo(() => {
    if (!totalItems || !rowsPerPage) {
      return 1;
    }
    return Math.max(1, Math.ceil(totalItems / rowsPerPage));
  }, [rowsPerPage, totalItems]);
  return <ListPageSelectorImpl firstPage={1} currentPage={page + 1} onChangePage={newPage => onChangePage(newPage - 1)} lastPage={lastPage} delta={delta} alwaysShowFirstPage={alwaysShowFirstPage} alwaysShowLastPage={alwaysShowLastPage} />;
}
export function ListPageSelectorImpl({
  onChangePage,
  firstPage,
  currentPage,
  lastPage,
  delta,
  alwaysShowFirstPage,
  alwaysShowLastPage
}) {
  const pageButtonOptions = useMemo(() => calculatePageOptions({
    firstPage,
    currentPage,
    lastPage,
    delta,
    alwaysShowFirstPage,
    alwaysShowLastPage
  }), [firstPage, currentPage, lastPage, delta, alwaysShowFirstPage, alwaysShowLastPage]);
  return <div css={styles.buttonsWrap}>
			<button type="button" css={[styles.button, firstPage <= currentPage - 1 && styles.buttonActive, process.env.NODE_ENV === "production" ? "" : ";label:ListPageSelectorImpl;"]} onClick={() => onChangePage(currentPage - 1)} disabled={firstPage > currentPage - 1} data-testid="pagination-left">
				<IconChevronLeft width={20} height={20} />
			</button>
			{pageButtonOptions.map((option, i) => {
      const isSelectedPage = currentPage === +option;
      return <button key={`${option}${i}`} type="button" css={[styles.button, option !== '...' && styles.buttonActive, isSelectedPage && styles.buttonSelected, process.env.NODE_ENV === "production" ? "" : ";label:ListPageSelectorImpl;"]} onClick={() => {
        if (typeof option === 'number') {
          onChangePage(option);
        }
      }} disabled={option === '...'} data-pagination-selected={isSelectedPage} data-testid="pagination-option">
						{option.toLocaleString()}
					</button>;
    })}
			<button type="button" css={[styles.button, styles.rightArrowBtn, currentPage + 1 <= lastPage && styles.buttonActive, process.env.NODE_ENV === "production" ? "" : ";label:ListPageSelectorImpl;"]} onClick={() => onChangePage(currentPage + 1)} disabled={currentPage + 1 > lastPage} data-testid="pagination-right">
				<IconChevronRight width={20} height={20} />
			</button>
		</div>;
}